import React, { useEffect, useMemo, useRef, useState } from "react";
import { InfiniteList2, OptionsPanelContainer } from "../../../../../../../common/components";
import { translate, translateDate } from "../../../../../../../common/providers";
import { ApiService, FormStudioService } from "../../../../../../../api";
import Box from "../../../../box/Box";
import { isEqual, isNonEmptyArray } from "../../../../../../../common/utils";
import styles from "./ProjectList.module.css";

export default function ProjectList({ view, onUpdateRow, projectsRequest }) {
	const cancelTokenSourceRef = useRef();
	const [projects, setProjects] = useState([]);
	const [tempProjects, setTempProjects] = useState([]);
	const { id } = view;
	useEffect(() => {
		cancelTokenSourceRef.current = ApiService.getCancelTokenSource();
		FormStudioService.getViewProjects({ pageId: id }, cancelTokenSourceRef.current.token).then((data) => {
			setProjects(data);
			setTempProjects(data.map((d) => d.id));
		});
		return () => {
			ApiService.cancelTokens(cancelTokenSourceRef.current);
		};
	}, [id]);
	const handleCheck = (data, checked) => {
		if (checked) {
			setTempProjects((prev) => prev.filter((tcp) => tcp !== data.id));
		} else {
			setTempProjects((prev) => [...prev, data.id]);
		}
	};
	const handleReset = () => {
		setTempProjects(projects);
	};

	const handleSave = () => {
		const toAdd = tempProjects.filter((tc) => !projects.some((c) => c.id === tc));
		const toRemove = projects.filter((tc) => !tempProjects.includes(tc.id)).map((ta) => ta.id);
		FormStudioService.updateViewProjects(
			{ pageId: id },
			{
				toAdd: isNonEmptyArray(toAdd) ? toAdd : undefined,
				toRemove: isNonEmptyArray(toRemove) ? toRemove : undefined,
			},
			cancelTokenSourceRef.current.token
		).then(() => {
			setProjects(tempProjects);
			onUpdateRow(id, "companies", tempProjects.length);
		});
	};
	const hasDiff = useMemo(
		() =>
			isEqual(
				projects.map((x) => x.id),
				tempProjects
			),
		[projects, tempProjects]
	);
	const rowRenderer = (project) => (
		<Box
			key={project.id}
			checked={tempProjects.includes(project.id)}
			content={translateDate(project.created)}
			data={project}
			id={project.id}
			title={project.name}
			onCheck={handleCheck}
		/>
	);
	return (
		<OptionsPanelContainer
			buttonText={translate("common:btn.save")}
			buttonTextSecondary={translate("common:btn.cancel")}
			disabledPrimaryButton={hasDiff}
			disabledSecondaryButton={hasDiff}
			onClick={handleSave}
			onClickSecondary={handleReset}
		>
			<InfiniteList2 hasSearch className={styles.container} request={projectsRequest} rowRenderer={rowRenderer} />
		</OptionsPanelContainer>
	);
}
